import { memo } from 'react';

import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { generateOrganizationTemplateText } from 'KnmErknmPackage/MainModule/common/generateOrganizationTemplateText';
import { TextInput } from 'UIPackage/MainModule/components/TextInput';
import { IKnmPmForm } from 'KnmPmPackage/MainModule/interfaces/IKnmPmForm';
import { Hint } from 'CorePackage/MainModule/components/Hint';

import styles from './ResultDecisionsItemContentActs.module.scss';

interface IResultDecisionsItemContentActsProps {
  values: IKnmPmForm | undefined;
}

export const ResultDecisionsItemContentActs = memo(({ values }: IResultDecisionsItemContentActsProps) => {
  return (
    <FieldBlock label={'Акт'} className={styles.GroupMarginBottom}>
      <FieldBlock>
        <TextInput
          disabled={true}
          value={`${values?.act?.numberAct} - ${generateOrganizationTemplateText(
            values?.inn || undefined,
            values?.ogrn || undefined,
            values?.organizationName || undefined,
            values?.rafpNza || undefined,
          )}`}
        />
      </FieldBlock>
      <Hint text="Выбор акта возможен только после внесения сведений об уведомлении об акте" />
    </FieldBlock>
  );
});
